var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ContextMenuComponent } from './context-menu.component';
import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../app/store/index';
import { Router, ActivatedRoute } from '@angular/router';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
var INDRAContextMenuComponent = /** @class */ (function (_super) {
    __extends(INDRAContextMenuComponent, _super);
    function INDRAContextMenuComponent(sidebarService, store, router, route, ibeAdminService) {
        var _this = _super.call(this) || this;
        _this.sidebarService = sidebarService;
        _this.store = store;
        _this.router = router;
        _this.route = route;
        _this.ibeAdminService = ibeAdminService;
        _this.bookedTrip$ = _this.store.select(fromStore.getSelectedBookedTrip);
        _this.back = new EventEmitter();
        _this.refresh = new EventEmitter();
        _this.newSearch = new EventEmitter();
        _this.actionsOpen = false;
        _this.hideSteps = false;
        _this.hiddeEdit = false;
        _this.isBack = true;
        _this.returnToSearch = false;
        _this.isAlive = true;
        _this.bookedTrip$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.passengers = value._passengers_info;
            }
        });
        return _this;
    }
    INDRAContextMenuComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        window.removeEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
    };
    INDRAContextMenuComponent.prototype.ngOnInit = function () {
        var splitTitle = this.title.split(' ');
        if (splitTitle.length > 2) {
            this.contextMenuStep = '';
            this.contextMenuTitle = splitTitle.join("");
        }
        else {
            this.contextMenuTitle = splitTitle[1].toLowerCase();
            this.contextMenuStep = splitTitle[0] + ' ';
        }
        window.addEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
    };
    /**
     * Emit back event to parent
     */
    INDRAContextMenuComponent.prototype.INDRA_handleBackButton = function () {
        if (this.returnToSearch) {
            this.newSearch.emit();
        }
        else {
            this.back.emit();
        }
    };
    INDRAContextMenuComponent.prototype.INDRA_handleActionsButton = function () {
        this.sidebarService.openSidebar([
            'edit-search',
        ]);
    };
    INDRAContextMenuComponent.prototype.INDRA_hideSteps = function () {
        return this.hideSteps;
    };
    INDRAContextMenuComponent.prototype.INDRA_hiddeEdit = function () {
        return this.hiddeEdit;
    };
    INDRAContextMenuComponent.prototype.INDRA_getTranslationKey = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRAContextMenuComponent.prototype.beforeUnloadHandler = function (event) {
        this.refresh.emit();
    };
    return INDRAContextMenuComponent;
}(ContextMenuComponent));
export { INDRAContextMenuComponent };
